import { i18n } from 'i18next'
import { CoreEvent, EventGeneric, TealiumEvent } from 'models/activity/v2'

export type SiteActivityConfig = EventGeneric<
    CoreEvent,
    TealiumEvent
>

export interface GeneratorArgs {
    i18n: i18n
}

export type SiteActivityConfigFn = (props: any) => SiteActivityConfig
export type GenericEventMap = Record<string, SiteActivityConfig | SiteActivityConfigFn>
export type EventMapGenerator<T extends GenericEventMap> = (args: GeneratorArgs) => T

export const generator = <T extends GenericEventMap>(func: EventMapGenerator<T>) => func

export type EventMapKeys<T extends EventMapGenerator<GenericEventMap>> = T extends (args: GeneratorArgs) => infer R ? keyof R : never;

export default generator
